const TICKS = 72;

// Dashed progress ring: lit ticks = remaining fraction, sweeping clockwise from 12 o'clock.
export const TickRing = ({ progress, children, paused }) => {
  const lit = progress * TICKS;
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[300px]" data-testid="timer-tick-ring">
      <svg viewBox="0 0 300 300" className="absolute inset-0 h-full w-full">
        {Array.from({ length: TICKS }).map((_, i) => {
          const on = Math.min(1, Math.max(0, lit - i));
          return (
            <line
              key={i}
              x1="150" y1="8" x2="150" y2="24"
              strokeWidth="4" strokeLinecap="round"
              transform={`rotate(${(i * 360) / TICKS} 150 150)`}
              stroke={on > 0 ? '#FFD700' : 'rgba(255,255,255,0.10)'}
              opacity={on > 0 ? 0.35 + 0.65 * on : 1}
              style={{ transition: 'stroke 300ms, opacity 300ms' }}
            />
          );
        })}
      </svg>
      <div
        className={`absolute inset-[13%] rounded-full bg-[#0b0b0b] border border-white/5 flex flex-col items-center justify-center shadow-[0_0_60px_rgba(255,215,0,0.08)_inset] transition-opacity ${paused ? 'opacity-70' : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

export default TickRing;
